export const escapeHtml = (html) => {
    const text = document.createTextNode(html);
    const p = document.createElement('span');
    p.appendChild(text);
    const innerHtml = p.innerHTML;
    text.remove();
    p.remove();
    return innerHtml;
};
